import React from 'react';
import Admins from '../components/admin/Admins';


const Admin = () => {
    return ( <Admins/> );
}
 
export default Admin;